// =============================================================
// 🔄 RealtimeSessionsFeed.jsx — Lista de sessões ao vivo
// =============================================================

import React, { useEffect, useState } from "react";
import { listenAllSessions } from "../../../services/iaDashboard/sessionsService";

export default function RealtimeSessionsFeed() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const unsub = listenAllSessions((list) => {
      setSessions(list.filter((s) => s.status !== "finalizada"));
    });

    return () => unsub && unsub();
  }, []);

  return (
    <div className="ia-realtime-box">
      <h3 className="ia-dashboard-panel-title">🔄 Sessões em andamento</h3>

      {sessions.length === 0 && (
        <p className="ia-realtime-empty">Nenhuma sessão em andamento.</p>
      )}

      {sessions.map((s) => (
        <div key={s.id} className="ia-realtime-feed-item">
          <div className="ia-realtime-row">
            <strong>{s.usuarioNome || "Usuário"}</strong>

            <span className="ia-tag">
              {s.status === "aceita" ? "Ativa" : "Pendente"}
            </span>
          </div>

          <div className="ia-realtime-sub">
            Avatar: <strong>{s.avatarName}</strong>{" "}
            {s.isTyping && <span className="ia-typing-dot">Digitando…</span>}
          </div>

          <div className="ia-realtime-sub">
            {s.operadorId ? (
              <span>👨‍💼 Operador: {s.operadorId}</span>
            ) : (
              <span>🤖 Controlada pela IA</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
